import type { UiState } from "instantsearch.js";
import { history } from "instantsearch.js/es/lib/routers";
import type { StateMapping } from "instantsearch.js/es/types";

export const SEARCH_QUERY_PARAM = "q";

type IndexUiState = {
	query?: string;
};

type SearchUiState = {
	"products-index"?: IndexUiState;
};

const stateMapping: StateMapping = {
	stateToRoute(uiState: UiState): UiState {
		const indexUiState = (uiState as SearchUiState)["products-index"] || {};
		const query = indexUiState.query;

		return (query ? { [SEARCH_QUERY_PARAM]: query } : {}) as UiState;
	},
	routeToState(routeState: UiState): UiState {
		const query = (routeState as Record<string, string>)[SEARCH_QUERY_PARAM];

		return {
			"products-index": {
				...(query && { query }),
			},
		} as UiState;
	},
};

export const searchRouting = {
	router: history(),
	stateMapping,
};
